import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridsterModule } from 'angular-gridster2';
import { ChartModule } from '@progress/kendo-angular-charts';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { WidgetsModule } from '../../widgets/widgets.module';
import { TamDashboardModule } from '../../components/tam-dashboard/tam-dashboard.module';
import { DashboardEditorComponent } from './dashboard-editor/dashboard-editor.component';
import { TileSettingWrapperComponent } from '../../components/dashboard/tile-setting/tile-setting-wrapper.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DashboardDialogComponent } from '../../components/dashboard/dashboard-dialog/dashboard-dialog.component';
import { DashboardDialogService } from '../../components/dashboard/dashboard-dialog/dashboard-dialog.service';
import { EntityDropdownComponent } from '../../components/dashboard/focus-setting/entity-dropdown/entity-dropdown.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FocusSettingComponent } from '../../components/dashboard/focus-setting/focus-setting.component';
import { TileSettingsComponent } from '../../components/dashboard/tile-setting/tile-settings/tile-settings.component';
import { TileSettingModule } from '../../components/dashboard/tile-setting/tile-setting.module';
import { DashboardService } from './dashboard.service';
import { DashboardViewerWrapperComponent } from './dashboard-viewer-wrapper/dashboard-viewer-wrapper.component';
import { WebTemplateViewModel } from '../../components/template/template-web.view-model';
import { PrintPreviewDashboardComponent } from '../print-dashboard/print-preview-dashboard/print-preview-dashboard.component';
import { PrintTileContainerComponent } from '../print-dashboard/print-tile-container/print-tile-container.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PrintPreviewDashboardService } from '../print-dashboard/print-preview-dashboard/print-preview-dashboard.service';
import { DashboardGridNoteService } from './dashboard-grid-note.service';

@NgModule({
    imports: [
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // 3rd party
        GridsterModule,
        // kendo
        ChartModule,
        DropDownsModule,
        PopupModule,
        InputsModule,
        TooltipModule,
        DialogsModule,
        // project
        DashboardRoutingModule,
        TileSettingModule,
        TamDashboardModule,
        WidgetsModule
    ],
    declarations: [
        DashboardEditorComponent,
        DashboardDialogComponent,
        EntityDropdownComponent,
        FocusSettingComponent,
        TileSettingWrapperComponent,
        TileSettingsComponent,
        DashboardViewerWrapperComponent,
        PrintPreviewDashboardComponent,
        PrintTileContainerComponent,
    ],
    providers: [
        DashboardDialogService,
        DashboardService,
        PrintPreviewDashboardService,
        WebTemplateViewModel,
        DashboardGridNoteService
    ],
    exports: [
        DashboardDialogComponent,
        DashboardEditorComponent,
        PrintPreviewDashboardComponent,
        PrintTileContainerComponent
    ]
})
export class DashboardModule { }
